import React, { useMemo } from 'react';

import { Select } from '@uikit';

import { Sorts } from '@shared/api/types/magicWall';

import { sortTypes } from './constants';

type Props = {
  sort: Sorts;
  setSort(value: Sorts): void;
};

const SortFilter = ({ sort, setSort }: Props) => {
  const selectOptions = useMemo(() => {
    return sortTypes.map((sortType) => ({ value: sortType.id, label: sortType.name }));
  }, []);

  const activeSortSelectOption = useMemo(
    () => selectOptions.find((option) => option.value === sort),
    [selectOptions, sort],
  );

  return (
    <div className="flex gap-4 items-center w-full lg:max-w-[283px]">
      <span className="font-medium flex-shrink-0 max-sm:basis-20">Sort By:</span>

      <Select
        className="min-w-[180px] w-full"
        value={activeSortSelectOption}
        isSearchable={false}
        shape="pill"
        onChange={(value) => setSort((value as any)?.value || null)}
        options={selectOptions}
      />
    </div>
  );
};

export default SortFilter;
